import { getAllSnapshotsNames } from "../s3/GetSnapshotsNames";
import { deleteSnapshot } from "../s3/DeleteSnapshot";
import {getTagsFromS3Object} from "../s3/GetTagsFromObject"

/* 
  Uploads an updated CSV to S3 
  < input = initialFileName, inputtedFileName, csvData >
*/

export async function SaveCSV(
  S3,
  initialFileName,
  fileName,
  csvData,
  isGenerateReport
) {
  // S3 bucket and fileName initialisation
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const selectedSnapshot = localStorage.getItem("selectedSnapshot");
  let initialTags = { status: "", uploadedBy: ""};

  // Filter out empty rows and columns
  const rows = csvData.split("\n");
  const filteredRows = rows.filter((row) => {
    return row.trim() !== "" && row.split(",").some((col) => col.trim() !== "");
  });
  // Join the filtered rows back together with line breaks
  const filteredCSVData = filteredRows.join("\n");

  //If the button to Generate Report is clicked, do not check the name
  if (!isGenerateReport && initialFileName != selectedSnapshot) {
    // Check if there are snapshots with the same name as inputtedFileName
    const snapshotNames = await getAllSnapshotsNames(S3);
    if (snapshotNames.includes(fileName + ".csv")) {
      console.error("Snapshot with the same name already exists:", fileName);
      throw new Error("Duplicate Error");
    }
  }

  // Save the CSV as there are no duplicates
  const csvKey =
    localStorage.getItem("s3Link") + "/Forms/Snapshots/" + fileName + ".csv";
  try {
    if (!isGenerateReport) {
      await deleteSnapshot(S3, initialFileName);
    } else {
      initialTags = await getTagsFromS3Object(S3, bucket, csvKey);
    }
console.log(initialTags)

    const tagging = isGenerateReport ? `status=${initialTags.status}&uploadedBy=${initialTags.uploadedBy}` : `status=In%20Progress&uploadedBy=${encodeURIComponent(localStorage.getItem("email"))}`;
    const uploadParams = {
      Bucket: bucket,
      Key: csvKey,
      Body: filteredCSVData,
    };
    if (tagging) uploadParams.Tagging = tagging;

    const uploadResponse = await S3.upload(uploadParams).promise();
    // Console Testing
    console.log("Snapshot uploaded successfully:", uploadResponse);
    console.log("tag:", tagging)
    return uploadResponse;
  } catch (error) {
    console.error("Error saving snapshot for later:", error);
    throw new Error("UploadError");
  }
}
